import React, { useLayoutEffect, useRef, useState } from 'react';
import MobileMenuButton from './MobileMenuButton';

const MobileMenuSection = ({ title, isActive, onClick, children }) => {
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const updateHeight = () => setContentHeight(el.scrollHeight);
    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, [children]);

  return (
    <div>
      <div
        className={`flex justify-between items-center p-3 border-b border-[#CDD0D2] cursor-pointer ${isActive ? 'bg-midnight-black' : ''}`}
        onClick={onClick}
      >
        <span className={`font-semibold ${isActive ? 'text-white' : ''}`}>{title}</span>
        <MobileMenuButton isOpen={isActive} onClick={onClick} />
      </div>

      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: isActive ? `${contentHeight}px` : '0px',
          opacity: isActive ? 1 : 0,
        }}>
        <div ref={contentRef}>{children}</div>
      </div>
    </div>
  );
};

export default MobileMenuSection;
